import Api from 'fou-api'
import VuexErrors from 'src/vuex/modules/errors'
import Errors from 'src/utils/helper/errors'

export default {
  namespaced: true,

  state () {
    return {
      families: [],
      queries: {
        name: null,
        page: 1,
        perPage: 20,
        uniqueName: '',
        id: ''
      },
      minLength: 2,
      excludeChar: ',',
      relatedFamilySiblings: [],
      familyGroupName: ''
    }
  },

  getters: {
    list: state => {
      return state.families
    },
    queries: state => {
      return state.queries
    },
    minLength: state => {
      return state.minLength
    },
    excludeChar: state => {
      return state.excludeChar
    },
    relatedFamilySiblings: state => {
      return state.relatedFamilySiblings
    },
    familyGroupName: state => {
      return state.familyGroupName
    }
  },

  mutations: {
    add (state, families = []) {
      state.families = [...families]
    },
    addRelatedFamilySiblings (state, relatedFamilySiblings = []) {
      state.relatedFamilySiblings = relatedFamilySiblings
    },
    setFamilyGroupName (state, familyGroupName = '') {
      state.familyGroupName = familyGroupName
    },
    setQueries (state, options) {
      if (options.page) {
        options.page = options.page * 1
      }
      if (options.perPage) {
        options.perPage = options.perPage * 1
      }
      if (options.uniqueName) {
        options.uniqueName = String(options.uniqueName)
      }
      if (options.name) {
        options.name = String(options.name)
      }

      if (options.id) {
        options.id = String(options.id)
      }
      if (options.submissionId) {
        options.submissionId = String(options.submissionId)
      }
      state.queries = Object.assign(state.queries, options)
    },
    clear (state) {
      state.families = []
      state.queries.uniqueName = ''
      state.queries.id = ''
    }
  },

  actions: {
    get ({ commit, state }, options = {}) {
      commit('setQueries', options)
      return new Promise((resolve, reject) => {
        Api.Families.getFamiliesWithoutSubmission(
          state.queries.name,
          (state.queries.page * 1),
          (state.queries.perPage * 1),
          state.queries.uniqueName,
          state.queries.id,
          state.queries.submissionId
        )
          .then((response) => {
            if (response.data.families) {
              const allFamilies = response.data.families
              commit('add', allFamilies)
            }
            resolve(response.data.families)
          })
          .catch((error) => {
            let err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    async getFamilySiblings ({commit, state}, data) {
      try {
        const response = await Api.Families.getFamilyGroupByFamilyId(data.familyId, data.submissionId)
        if (response.data.families) {
          commit('addRelatedFamilySiblings', response.data.families)
          commit('setFamilyGroupName', response.data.familyGroupName)
        }
        return response.data.families
      } catch (error) {
        const err = Errors.create(error)
        commit('errors/add', err)
        throw err
      }
    },
    async getIhRelatedFamilies({ commit }, data) {
      try {
          const response = await Api.InventoryIngestionSubmissions.getIhRelatedFamilies(data.inventoryIngestionId, data.submissionId, data.familyId)
              commit('addRelatedFamilySiblings', response.data)
              commit('setFamilyGroupName', response.data.familyGroupName)
         return response.data.families
      } catch (error) {
          const err = Errors.create(error)
          commit('errors/add', err)
          throw err
      }
    },
    resetFamilies ({ commit }) {
      return new Promise(resolve => {
        commit('clear')
        resolve()
      })
    }

  },

  modules: {
    errors: VuexErrors
  }
}
